<template>
    <modal id="unlock-project-modal" class-name="modal-danger">
        <template slot="title">
            Unlock Project Request
        </template>
        <template slot="body">
            <p>
                This action will request NLCAA Staff to unlock the project.<br>
                By unlocking the project, all signatures will be deleted and the forms and project information will be available to edit.
            </p>
            <field-text v-model="form.reason" :with-placeholder="true" placeholder="What's the reason for unlocking this job?"></field-text>
        </template>
        <template slot="footer">
            <button class="btn btn-default" @click="closeModal('unlock-project-modal')">
                Cancel
            </button>
            <button class="btn btn-danger" @click="unlock()">Submit Request</button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            project: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                form: new Form({
                    reason: '',
                })
            }
        },

        methods: {
            unlock() {
                this.form.post(`/projects/${this.project.slug}/acceptance-documents/unlock`).then(() => {
                    this.closeModal('unlock-project-modal');
                    Toast.info('Your request has been sent!');
                }).catch(errors => {
                    Alert.error(errors.first());
                })
            }
        }

    }
</script>
